import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost, doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const retrieveEntities = createAsyncThunk(
  "retrieveEntities",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.retrieveEntities, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportEntities = createAsyncThunk(
  "exportEntities",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPostDownload(urls?.retrieveEntities, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const retrieveEntitiesSlice = createSlice({
  name: "retrieveEntities",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    retrieveEntitiesReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [retrieveEntities.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [retrieveEntities.pending]: (state) => {
      state.isLoading = true;
      state.data = false;
      state.error = null;
    },
    [retrieveEntities.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const exportEntitiesSlice = createSlice({
  name: "exportEntities",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    exportEntitiesReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [exportEntities.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [exportEntities.pending]: (state) => {
      state.isLoading = true;
      state.data = false;
      state.error = null;
    },
    [exportEntities.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const { retrieveEntitiesReset } = retrieveEntitiesSlice.actions;
export const { exportEntitiesReset } = exportEntitiesSlice.actions;
